import { boot } from 'quasar/wrappers'
import axios from 'axios'

// Be careful when using SSR for cross-request state pollution
// due to creating a Singleton instance here;
// If any client changes this (global) instance, it might be a
// good idea to move this instance creation inside of the
// "export default () => {}" function below (which runs individually
// for each client)
// 10-08-2022: prestar atención que las rutas de configuración están en 'quasar.config.js'
// 21-12-2025: Agregado fallback robusto para desarrollo y producción
const getApiUrl = () => {
  // Si existe la variable de entorno, usarla
  if (process.env.API_URL) {
    return process.env.API_URL
  }

  // Fallback: detectar si está en desarrollo
  const isDevelopment = process.env.NODE_ENV === 'development' ||
                        window.location.hostname === 'localhost' ||
                        window.location.hostname === '127.0.0.1'

  return isDevelopment
    ? 'http://localhost:4000/api/'
    : 'https://servidor.pbo-transfers.com/api'
}

const apiUrl = getApiUrl()

const api = axios.create({
  baseURL: apiUrl
})

// Interceptor para enviar version_cli en todas las peticiones
// Quasar inyecta automáticamente process.env.VERSION desde package.json
// Si no hay versión, no enviar version_cli (el servidor usará estructura antigua)
const VERSION_CLI = process.env.VERSION || null

api.interceptors.request.use(config => {
  // Agregar version_cli a todas las peticiones solo si existe
  if (VERSION_CLI) {
    if (config.params) {
      config.params.version_cli = VERSION_CLI
    } else {
      config.params = { version_cli: VERSION_CLI }
    }
  }

  return config
}, error => {
  return Promise.reject(error)
})

export default boot(({ app }) => {
  // for use inside Vue files (Options API) through this.$axios and this.$api

  app.config.globalProperties.$axios = axios
  // ^ ^ ^ this will allow you to use this.$axios (for Vue Options API form)
  //       so you won't necessarily have to import axios in each vue file

  app.config.globalProperties.$api = api
  // ^ ^ ^ this will allow you to use this.$api (for Vue Options API form)
  //       so you can easily perform requests against your app's API
})

export { api }
